import {
  useUpdateClientMutation,
  useDeleteClientMutation,
} from 'actions/clients/mutations';
import { toast } from 'react-toastify';
import { useGetClientQuery } from 'actions/clients/queries';
import { extractListData, formatQueryError } from 'utils/queryHelpers';

const useClientData = (dossierId) => {
  const {
    data: clientResponse,
    error,
    isLoading,
    refetch,
  } = useGetClientQuery({ dossier_id: dossierId });

  const [updateClient] = useUpdateClientMutation();
  const [deleteClient] = useDeleteClientMutation();

  // CORRECTION : exposer l'erreur pour que la page ne la confonde pas
  // avec une liste vide. extractListData retourne [] seulement si pas d'erreur.
  const updatedClients = extractListData(clientResponse, error, isLoading).map((client) => ({
    ...client,
    displayName: `${client.nom} (${client.id})`,
  }));

  const queryError = error ? formatQueryError(error) : null;

  const handleUpdateClient = async (clientId, updateData) => {
    try {
      await updateClient({
        id: clientId,
        ...updateData,
      }).unwrap();
      // Attendre que le refetch se termine
      await refetch();
    } catch (error) {
      toast.error(`Update error: ${error.data?.error || error.message}`);
      console.error('Request failed:', error);
    }
  };

  const handleDeleteClient = async (clientId) => {
    try {
      await deleteClient({ id: clientId }).unwrap();
      toast.success('Client supprimé avec succès');
      // Attendre que le refetch se termine
      await refetch();
    } catch (error) {
      console.log(clientId);
      // Afficher le message d'erreur du backend s'il existe
      const errorMessage = error.data?.message || error.data?.error || error.message;
      toast.error(errorMessage);
    }
  };

  return { updatedClients, handleUpdateClient, handleDeleteClient, refetch, error: queryError, isLoading };
};

export default useClientData;
